import React from 'react';
import styled from 'styled-components';
import ol from './ol.png';

const Span = styled.div`
  margin-top: 2px;
  margin-left: 2px;
  position: absolute;
`;

const Icon = styled.div`
  width: 18px;
  height: 18px;
  background-image: url(${ol});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const OLIcon = () => {
  return (
    <Span>
      <Icon />
    </Span>
  );
};

export default OLIcon;
